<template>
	<widget-card
		colClasses="xs12"
		:heading="widget.text.caption[$i18n.locale]">
		<div v-html="widget.data.content"></div>
	</widget-card>
</template>

<script>
	import Enumerable from 'linq'
	import PieChart from './PieChart.js'
	import { mapGetters } from 'vuex'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		components: {
			PieChart
		},
		computed: {
			...mapGetters([
				'season',
				'reportingData'
			])
		},
		data() {
			return {
				eventGroup: ''
			}
		},
		methods: {
			
		}
	};
</script>

